var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chargebee-upsell-config-pv3" }, [
    _c(
      "h4",
      {
        staticClass:
          "typographies-paragraph-x-large-semibold chargebee-upsell-config-pv3__subtitle"
      },
      [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Nombre d'utilisateurs")) +
            "\n    "
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "chargebee-upsell-config-pv3__item chargebee-upsell-config-pv3__staff-container"
      },
      [
        _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Utilisateur")))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "chargebee-upsell-config-pv3__item--right" },
          [
            _c("CompassNumberInput", {
              attrs: {
                disabled: _vm.getEstimationLoading,
                "model-value": _vm.staffsNumber,
                min: _vm.previousStaffsNumber
              },
              on: {
                change: function(newValue) {
                  return _vm.updateStaffsQuantity("pack_crm_full", newValue)
                }
              }
            }),
            _vm._v(" "),
            _c("div", [
              _c(
                "span",
                { staticClass: "typographies-paragraph-medium-semibold" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm._f("numberformatCurrency")(
                          _vm.options.pack_crm.price / 100
                        )
                      ) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "typographies-paragraph-small-regular" },
                [
                  _vm._v(
                    "\n                    /" +
                      _vm._s(_vm.recurrencyLabel(_vm.getRecurrence)) +
                      "\n                "
                  )
                ]
              )
            ])
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "h4",
      {
        staticClass:
          "typographies-paragraph-x-large-semibold chargebee-upsell-config-pv3__subtitle"
      },
      [_vm._v("\n        " + _vm._s(_vm.$l10n.__("Options")) + "\n    ")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "chargebee-upsell-config-pv3__item" }, [
      _c(
        "div",
        { staticClass: "chargebee-upsell-config-pv3__item--left" },
        [
          _c(
            "CompassTooltip",
            {
              attrs: {
                content: _vm.getContentTooltip(
                  _vm.isOptionEnabled("pack_invoicing")
                )
              }
            },
            [
              _c("CompassSwitch", {
                attrs: {
                  disabled: true,
                  value: _vm.isOptionEnabled("pack_invoicing")
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chargebee-upsell-config-pv3__item--left-text" },
            [
              _c(
                "span",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.options.pack_invoicing.label) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "typographies-paragraph-medium-regular chargebee-upsell-config-pv3__item--left-text-description"
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Transformez vos devis en factures, activez la signature électronique et faites vous payer en ligne."
                        )
                      ) +
                      "\n                "
                  )
                ]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "chargebee-upsell-config-pv3__item--right" }, [
        _c("div", [
          _c(
            "span",
            { staticClass: "typographies-paragraph-medium-semibold" },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm._f("numberformatCurrency")(
                      _vm.options.pack_invoicing.price / 100
                    )
                  ) +
                  "\n                "
              )
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "typographies-paragraph-small-regular" }, [
            _vm._v(
              "\n                    /" +
                _vm._s(_vm.recurrencyLabel(_vm.getRecurrence)) +
                "\n                "
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "chargebee-upsell-config-pv3__item" }, [
      _c(
        "div",
        { staticClass: "chargebee-upsell-config-pv3__item--left" },
        [
          _c(
            "CompassTooltip",
            {
              attrs: {
                content: _vm.getContentTooltip(
                  _vm.isOptionEnabled("pack_management")
                )
              }
            },
            [
              _c("CompassSwitch", {
                attrs: {
                  disabled: true,
                  value: _vm.isOptionEnabled("pack_management")
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chargebee-upsell-config-pv3__item--left-text" },
            [
              _c(
                "span",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.options.pack_management.label) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "typographies-paragraph-medium-regular chargebee-upsell-config-pv3__item--left-text-description"
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Saisissez vos achats, calculez vos marges, liez vos banques et exportez les écritures comptables."
                        )
                      ) +
                      "\n                "
                  )
                ]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "chargebee-upsell-config-pv3__item--right" }, [
        _c("div", [
          _c(
            "span",
            { staticClass: "typographies-paragraph-medium-semibold" },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm._f("numberformatCurrency")(
                      _vm.options.pack_management.price / 100
                    )
                  ) +
                  "\n                "
              )
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "typographies-paragraph-small-regular" }, [
            _vm._v(
              "\n                    /" +
                _vm._s(_vm.recurrencyLabel(_vm.getRecurrence)) +
                "\n                "
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.isOptionEnabled("pack_stock")
      ? _c("div", { staticClass: "chargebee-upsell-config-pv3__item" }, [
          _c(
            "div",
            { staticClass: "chargebee-upsell-config-pv3__item--left" },
            [
              _c(
                "CompassTooltip",
                {
                  attrs: {
                    content: _vm.getContentTooltip(
                      _vm.isOptionEnabled("pack_stock")
                    )
                  }
                },
                [
                  _c("CompassSwitch", {
                    attrs: { disabled: true, value: true }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chargebee-upsell-config-pv3__item--left-text" },
                [
                  _c(
                    "span",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.options.pack_stock.label) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass:
                        "typographies-paragraph-medium-regular chargebee-upsell-config-pv3__item--left-text-description"
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Gérez vos stocks, vos entrepôts, vos commandes et soyez alerté en cas de rupture."
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chargebee-upsell-config-pv3__item--right" },
            [
              _c("div", [
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-medium-semibold" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm._f("numberformatCurrency")(
                            _vm.options.pack_stock.price / 100
                          )
                        ) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-small-regular" },
                  [
                    _vm._v(
                      "\n                    /" +
                        _vm._s(_vm.recurrencyLabel(_vm.getRecurrence)) +
                        "\n                "
                    )
                  ]
                )
              ])
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isOptionEnabled("pack_support")
      ? _c("div", { staticClass: "chargebee-upsell-config-pv3__item" }, [
          _c(
            "div",
            { staticClass: "chargebee-upsell-config-pv3__item--left" },
            [
              _c(
                "CompassTooltip",
                {
                  attrs: {
                    content: _vm.getContentTooltip(
                      _vm.isOptionEnabled("pack_support")
                    )
                  }
                },
                [
                  _c("CompassSwitch", {
                    attrs: { disabled: true, value: true }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chargebee-upsell-config-pv3__item--left-text" },
                [
                  _c(
                    "span",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.options.pack_support.label) +
                          "\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticClass:
                        "typographies-paragraph-medium-regular chargebee-upsell-config-pv3__item--left-text-description"
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Affectez les tickets en un clic à vos collaborateurs, proposez un service personnalisé à vos clients."
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chargebee-upsell-config-pv3__item--right" },
            [
              _c("div", [
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-medium-semibold" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm._f("numberformatCurrency")(
                            _vm.options.pack_support.price / 100
                          )
                        ) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-small-regular" },
                  [
                    _vm._v(
                      "\n                    /" +
                        _vm._s(_vm.recurrencyLabel(_vm.getRecurrence)) +
                        "\n                "
                    )
                  ]
                )
              ])
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "chargebee-upsell-config-pv3__item" }, [
      _c(
        "div",
        { staticClass: "chargebee-upsell-config-pv3__item--left" },
        [
          _c(
            "CompassTooltip",
            {
              attrs: {
                content: _vm.getContentTooltip(
                  _vm.isOptionEnabled("pack_cashflow")
                )
              }
            },
            [
              _c("CompassSwitch", {
                attrs: {
                  disabled: true,
                  value: _vm.isOptionEnabled("pack_cashflow")
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chargebee-upsell-config-pv3__item--left-text" },
            [
              _c(
                "span",
                { staticClass: "typographies-paragraph-medium-regular" },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$l10n.__("Trésorerie")) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "typographies-paragraph-medium-regular chargebee-upsell-config-pv3__item--left-text-description"
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.$l10n.__(
                          "Visualisez votre trésorerie en temps réel et réalisez des prévisions."
                        )
                      ) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "CompassSelect",
                {
                  attrs: {
                    disabled: !_vm.isOptionEnabled("pack_cashflow"),
                    value: _vm.cashflowSelectedValue.id
                  },
                  on: {
                    "update:value": function(value) {
                      return _vm.updateLevelOption({
                        optionNameKey: "pack_cashflow",
                        optionId: value
                      })
                    }
                  }
                },
                _vm._l(_vm.options.pack_cashflow, function(selectOption) {
                  return _c("CompassDropdownSelectOption", {
                    key: selectOption.id,
                    attrs: {
                      label: _vm.labelCashflow[selectOption.item_id],
                      value: selectOption.id,
                      caption: _vm.getCaptionSelectPrice(selectOption)
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "chargebee-upsell-config-pv3__item--right" }, [
        _c("div", [
          _c(
            "span",
            { staticClass: "typographies-paragraph-medium-semibold" },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(
                    _vm._f("numberformatCurrency")(
                      _vm.cashflowSelectedValue.unit_price / 100
                    )
                  ) +
                  "\n                "
              )
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "typographies-paragraph-small-regular" }, [
            _vm._v(
              "\n                    /" +
                _vm._s(_vm.recurrencyLabel(_vm.getRecurrence)) +
                "\n                "
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }